import { InjectionToken } from '@rxdi/core';
import { Observable } from 'rxjs';

type TranslationsType = Promise<Record<string, string>> | Observable<Record<string, string>> | Record<string, string>;

export interface TranslationsConfig {
  translations: Record<string, TranslationsType>;
  languages?: string[];
}

export const TranslationsConfig = new InjectionToken<TranslationsConfig>('translations-config');
